export const FormatList = [
  {
    displayTitle: 'MP3',
    displaySubTitle: '128 Kbps',
    params: {
      format: 'mp3',
      sampleRate: 44100,
      bitRate: 128,
    },
  },
  {
    displayTitle: 'MP3',
    displaySubTitle: '192 Kbps',
    params: {
      format: 'mp3',
      sampleRate: 44100,
      bitRate: 192,
    },
  },
  {
    displayTitle: 'MP3',
    displaySubTitle: '320 Kbps',
    params: {
      format: 'mp3',
      sampleRate: 44100,
      bitRate: 320,
    },
  },
  {
    displayTitle: 'WAV',
    displaySubTitle: '44.1 kHz / 16bit',
    params: {
      format: 'wav',
      sampleRate: 44100,
      bitRate: 0,
    },
  },
  // {
  //   displayTitle: 'WAV',
  //   displaySubTitle: '48 kHz / 16bit',
  //   params: {
  //     format: 'wav',
  //     sampleRate: 48000,
  //     bitRate: 0,
  //   },
  // },
];
